import { useAtom } from 'jotai'

import { highlightedCellAtom } from '~/atoms/highlightedCellAtom'

const HighlightProps = (
  highlightedCell: Record<string, boolean>,
  setHighlightedCells: (
    fn: (prev: Record<string, boolean>) => Record<string, boolean>,
  ) => void,
  key: string,
) => ({
  onClick: () =>
    setHighlightedCells((prev) => ({
      ...prev,
      [key]: !prev[key],
    })),
  isHighlighted: highlightedCell[key] ?? false,
})

export const useHighlightCells = (keyPrefix: string) => {
  const [highlightedCell, setHighlightedCells] = useAtom(highlightedCellAtom)

  const addHighlightProps = (key: string) =>
    HighlightProps(highlightedCell, setHighlightedCells, `${keyPrefix}::${key}`)

  return { addHighlightProps }
}
